import { render } from "./OtiForOp.vue?vue&type=template&id=4c2f25ba&scoped=true"
import script from "./OtiForOp.vue?vue&type=script&lang=js"
export * from "./OtiForOp.vue?vue&type=script&lang=js"

import "./OtiForOp.vue?vue&type=style&index=0&id=4c2f25ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2f25ba"]])

export default __exports__